module.exports = __webpack_public_path__ + "static/img/matching.4bf8e40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/order/matching.png
// module id = ryRi
// module chunks = 1